import { type RequestBody } from '../http/type-helpers';

import { type DetailedBag } from './aliases';

import {
  BAG_BASIC_ENDPOINT,
  BAG_DETAILED_ENDPOINT,
  BAG_GUEST_DETAILED_ENDPOINT,
  UPDATE_BAG_ENDPOINT,
} from '@/constants/endpoints';
import { typedHttp } from '@/modules/http';
import { type AxiosCompatibleResponse } from '@/modules/http/types';

export function getAuthBagBasic() {
  return typedHttp.get(BAG_BASIC_ENDPOINT, { withAuth: true });
}

export function getAuthBagDetailed({
  lang,
  includeOffers,
  includeSellerSettings,
}: {
  lang: string;
  includeOffers?: boolean;
  includeSellerSettings?: boolean;
}) {
  return typedHttp.get(BAG_DETAILED_ENDPOINT, {
    withAuth: true,
    withDeviceId: true,
    params: {
      lang,
      include_offers: includeOffers,
      include_seller_settings: includeSellerSettings,
    },
  });
}

export function getGuestBagDetailed({
  lang,
  bagItems,
}: {
  lang: string;
  bagItems: RequestBody<typeof BAG_GUEST_DETAILED_ENDPOINT>;
}): Promise<AxiosCompatibleResponse<DetailedBag>> {
  return typedHttp.post(BAG_GUEST_DETAILED_ENDPOINT, bagItems, {
    withAuth: false,
    withDeviceId: true,
    params: {
      lang,
    },
  });
}

export function updateAuthBag(
  data: RequestBody<typeof UPDATE_BAG_ENDPOINT, 'patch'>
) {
  return typedHttp.patch(UPDATE_BAG_ENDPOINT, data, { withAuth: true });
}
